import React, { FC, useState, useEffect } from 'react';

import { OpenaiAccount } from 'models/entities/openai';
import { Model } from './index.model';

import { useModal } from '../../services/use-modal';
import { TextInput } from 'views/components/text-input';
import { PrimaryButton, SecondaryButton, SecondaryRoundButton } from 'views/components/buttons';
import { TrashIcon } from 'views/components/icons';
import { Root, Footer, MoreActions } from './index.styled';

interface Props {
  target: OpenaiAccount;
  ready: boolean;
}

const EditOpenaiAccount: FC<Props> = ({ target, ready }) => {

  const modal = useModal();
  const [model, setModel] = useState(new Model({ target }));

  function save() {
    model.save().then(model => modal.close({ state: model.isNew ? 'created' : 'updated', target: model.result }));
  }

  function cancel() {
    modal.close();
  }

  function remove() {
    if (model.isNew) return;
    model.delete().then(model => modal.close({ state: 'deleted', target: model.result }));
  }

  return (
    <Root>
      <h1>OpenAI Account</h1>
      <fieldset>
        <TextInput value={model.apiKey} onChange={e => setModel(model.change({ apiKey: e.target.value }))} inFocus={ready} placeholder={model.currentApiKey}>
          <h2>API Key</h2>
        </TextInput>
        <TextInput value={model.organizationId} onChange={e => setModel(model.change({ organizationId: e.target.value }))} placeholder={model.currentOrganizationId}>
          <h2>Organization ID</h2>
        </TextInput>
      </fieldset>
      <Footer>
        <SecondaryButton onClick={() => cancel()}>Cancel</SecondaryButton>
        <PrimaryButton onClick={() => save()} disabled={!model.result}>Save</PrimaryButton>
      </Footer>
      {!model.isNew && (
        <MoreActions>
          <div>
            <SecondaryRoundButton onClick={() => remove()} tabIndex={-1}><TrashIcon /></SecondaryRoundButton>
          </div>
        </MoreActions>
      )}
    </Root>
  );

};

export { EditOpenaiAccount };
